<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('dashboard.CardSettingOverlay.title') + cardCustomSettings.title"
        class="card-setting-overlay"
        @before-close="close"
        @closed="close"
    >
        <preloader :display="loading" />
        <template #default>
            <div class="dialog__default">
                <p>
                    {{
                        $l10n.__(
                            'Définissez les informations à afficher sur la carte pour personnaliser votre tableau de bord selon vos besoins.',
                        )
                    }}
                </p>
                <!-- TITLE FORM -->
                <el-form
                    ref="formOverlay"
                    :model="form"
                    :rules="titleRules"
                    :validateOnRuleChange="false"
                    labelPosition="top"
                >
                    <el-form-item
                        prop="title"
                        :label="$t.__('dashboard.CardSettingOverlay.card_name')"
                        class="mb-2"
                    >
                        <el-input
                            v-model="form.title"
                            type="text"
                            rows="1"
                            :maxlength="titleMaxLength"
                            class="wp-3"
                            @change="formatTitle"
                        />
                    </el-form-item>
                    <!-- COMPONENT SETTING FORM -->
                    <component
                        :is="formName"
                        :form="form"
                        :cardCustomSettings="cardCustomSettings"
                        :cardName="cardName"
                        :cardSettings="cardSettings"
                        :loading="loading"
                        @close-form="close"
                        @save-settings="save"
                        @set-rules="init"
                        @updateLoading="setLoading"
                    />
                </el-form>
            </div>
        </template>
    </CompassDialog>
</template>
<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
/* Import your setting form for the cards */
import PurInvoiceSettingForm from './forms/PurInvoiceSettingForm.vue';
import EstimateSettingForm from './forms/EstimateSettingForm.vue';
import InvoiceSettingForm from './forms/InvoiceSettingForm.vue';
import TurnoverSettingForm from './forms/TurnoverSettingForm.vue';
import TaskSettingForm from './forms/TaskSettingForm.vue';
import AgendaSettingForm from './forms/AgendaSettingForm.vue';
import BankAccountBalanceSettingForm from './forms/BankAccountBalanceSettingForm.vue';
import OpportunitySettingForm from './forms/OpportunitySettingForm.vue';
import InvoiceUnreconciledSettingForm from './forms/InvoiceUnreconciledSettingForm.vue';
import OrderSettingForm from './forms/OrderSettingForm.vue';
import ProformaSettingForm from './forms/ProformaSettingForm.vue';
import LastObjectSettingForm from './forms/LastObjectSettingForm.vue';

export default {
    components: {
        Preloader,
        /* Declaring the setting form cards here */
        PurInvoiceSettingForm,
        EstimateSettingForm,
        InvoiceSettingForm,
        TurnoverSettingForm,
        TaskSettingForm,
        AgendaSettingForm,
        BankAccountBalanceSettingForm,
        OpportunitySettingForm,
        InvoiceUnreconciledSettingForm,
        OrderSettingForm,
        ProformaSettingForm,
        LastObjectSettingForm,
    },
    props: {
        formName: {
            type: String,
            required: true,
        },
        cardCustomSettings: {
            type: [Object, Array],
            required: true,
            default() {
                return {};
            },
        },
        cardName: {
            type: String,
            required: true,
        },
        cardSettings: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
    },
    data() {
        const titleMaxLength = 30;
        const titleMinLength = 2;

        return {
            showModal: true,
            titleMaxLength: titleMaxLength,
            titleRules: {
                title: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez donner un titre à votre carte'),
                        trigger: 'blur',
                    },
                    {
                        min: titleMinLength,
                        max: titleMaxLength,
                        message: this.$l10n.n__(
                            'Le titre doit faire entre %(min)s et %(max)s caractères',
                            'Le titre doit faire entre %(min)s et %(max)s caractères',
                            { min: titleMinLength, max: titleMaxLength },
                            { min: titleMinLength, max: titleMaxLength },
                        ),
                        trigger: 'blur',
                    },
                ],
            },
            /* Don't work if it's not a object :/ */
            form: this.cardCustomSettings,
            loading: false,
        };
    },
    methods: {
        formatTitle(title) {
            this.form.title = title.trim();
        },
        setLoading(payload) {
            this.loading = payload.loading;
        },
        save() {
            this.$refs['formOverlay'].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$ajax.post(
                        `/home/card/settings/save/${this.cardName}`,
                        {},
                        { settings: this.form },
                        (response) => {
                            Push.success(
                                this.$l10n.__('La configuration a bien été prise en compte.'),
                            );
                            this.$emit('close-form');
                            this.$emit('custom-settings-saved');
                            this.loading = false;
                        },
                        (error) => {
                            Push.error(
                                this.$l10n.__(
                                    "Une erreur s'est produite lors de l'enregistrement.",
                                ),
                            );
                            this.loading = false;
                        },
                    );
                } else {
                    return false;
                }
            });
        },
        close() {
            this.$emit('close-form');
        },
        init(rules) {
            this.titleRules = { ...this.titleRules, ...rules };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';
.card-setting-overlay {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }
    }
}
</style>
